import { render, staticRenderFns } from "./chart-top-players.vue?vue&type=template&id=4d782b1d&scoped=true&"
import script from "./chart-top-players.vue?vue&type=script&lang=js&"
export * from "./chart-top-players.vue?vue&type=script&lang=js&"
import style0 from "./chart-top-players.vue?vue&type=style&index=0&id=4d782b1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d782b1d",
  null
  
)

export default component.exports